module.exports = __webpack_public_path__ + "static/img/about01-mobile.b146afb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about01-mobile.png
// module id = JvSt
// module chunks = 1